import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Grid,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import MoreIcon from "@mui/icons-material/MoreVert";
import { getPaymentHash } from "redux/actions/UserPayment";
import { getPayu } from "redux/actions/UserPayu";
import { getTrip } from "redux/actions/UserTrip";
import {
  getCancelReason,
  getTripCheckout,
} from "redux/actions/UserCustomerTrip";
import { postCashfreepayment } from "redux/actions/UserCashFreeAction";
import CancelReason from "pages/cancelReason/CancelReason";
import CommonForm from "components/commonForm/CommonForm";
import CouponDesign from "./CouponDesign";
import Map from "pages/Map/Map";
import { cashfree, dateFormate, truncateComment } from "utils/utils";
import { tripEnumObject } from "utils/enumObject";
import {
  FacilitiesData,
  fareData,
  onewayRulePoint,
  rulePoints,
} from "./FacilitiesData";
import calender from "assets/images/calender.svg";
import clock from "assets/images/clock.svg";
import whiteCar from "assets/images/whiteCar.svg";
import pickup from "assets/images/pickUp.svg";
import drop from "assets/images/drop.svg";
import editIcon from "assets/images/editIcon.svg";
import cancel from "assets/images/cancel.svg";
import share from "assets/images/share.svg";
import edit from "assets/images/greyEdit.svg";
import wifi from "assets/images/wifi.svg";
import myrideIcon from "assets/images/myrideActive.svg";
import charger from "assets/images/charger.svg";
import snacks from "assets/images/snacks.svg";
import newspaper from "assets/images/newspaper.svg";
import water from "assets/images/water.svg";

function ComfirmPay() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [openDialog, setOpenDialog] = useState(false);
  const merchantKey = process.env.REACT_APP_PAYU_MERCHANT_KEY;
  const paths = JSON.parse(sessionStorage.getItem("paths"));
  const params = {};
  searchParams.forEach((value, key) => {
    params[key] = value;
  });
  const pickupLatLng = JSON.parse(sessionStorage.getItem("pickupLatLng"));
  const type = searchParams.get("type");
  const status =
    type === tripEnumObject?.rental
      ? "Rental"
      : type === tripEnumObject?.airport
      ? "Airport"
      : type === tripEnumObject?.outStationRound
      ? "Outstation"
      : "Oneway";
  //added this to check for two screen , until payu works In future we will remove
  const { state } = useLocation();
  const dispatch = useDispatch();
  const rideStatus = state?.rideStatus;
  const hashValue = useSelector(
    (state) => state?.userPaymentHash?.userPaymentHash?.data?.sha
  );
  const loading = useSelector((state) => state?.userPaymentHash?.loading);
  const cancelReasonData = useSelector(
    (state) => state?.userCancelReason?.userCancelReason?.data
  );
  const sessionId = useSelector(
    (state) => state?.userCashFree?.userCashfree?.data?.payment_session_id
  );
  const tripData = useSelector((state) => state?.userTrip?.userTrip?.data);
  const tripCheckoutData = useSelector(
    (state) => state?.userTripCheckout?.userTripCheckout?.data?.tripDetails
  );
  const couponApplyDate = useSelector(
    (state) => state?.userCouponApply?.userCouponApply?.data
  );
  const couponRentalApplyDate = useSelector(
    (state) => state?.userRentalCouponApply?.userCouponRental?.data
  );
  const sessionPickup = sessionStorage.getItem("pickup");
  const sessionDrop = sessionStorage.getItem("drop");
  const dateOne = sessionStorage.getItem("date");
  const endDateOne = sessionStorage.getItem("endDate");
  const decodedPoints = JSON.parse(sessionStorage.getItem("decodedPoints"));
  const rideInclusion = JSON.parse(sessionStorage.getItem("rideInclusion"));
 

  const formData = [
    {
      type: "checkbox",
      content: "I accept the ",
      link: "Terms & Conditions",
    },
  ];
  const onClickEditBtn = () => {
    localStorage.setItem("isEdit", true);
    localStorage.removeItem("trip");
    navigate("/ride?type=" + type);
  };
  const redirect = () => {
    navigate("/ride?type=" + type);
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event, data) => {
    setAnchorEl(event.currentTarget);
  };
  const handleOnError = (e, facilityName) => {
    let replacementImage;
    switch (facilityName) {
      case "pepper spray":
        replacementImage = wifi;
        break;
      case "Snack":
        replacementImage = snacks;
        break;
      case "Charger":
        replacementImage = charger;
        break;
      case "Newspaper":
        replacementImage = newspaper;
        break;
      case "Water Bottel":
        replacementImage = water;
        break;
      default:
        replacementImage = wifi;
    }
    e.target.src = replacementImage;
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const ride = useSelector((state) => state?.userTrip?.userTrip?.data);
  const handleCancelClose = () => {
    setOpenDialog(!openDialog);
  };
  const polyline = state?.tripCheckout?.polyLine?.coordinates?.[0];
  const polylineData = polyline?.map((item) => {
    return { lat: item[0], lng: item[1] };
  });
  const pathData =
    (polylineData?.length > 0 && polylineData) || (paths?.length > 0 && paths);
  // TODO: will use for PayU
  // useEffect(() => {
  //   const paymentSUrl = process.env.REACT_APP_PAYMENT_SUCCESS_URL
  //   const paymentFUrl = process.env.REACT_APP_PAYMENT_FAILED_URL
  //   const payload = {
  //     key: merchantKey,
  //     txnid: state?.tripCheckout?.transactionId,
  //     amount: state?.tripCheckout?.amount,
  //     firstname: name,
  //     email: email,
  //     phone: mobile,
  //     productinfo: state?.tripCheckout?.tripDetails?.id,
  //     surl: paymentSUrl,
  //     furl: paymentFUrl,
  //     hash: hashValue,
  // };
  //   if (hashValue) {
  //     dispatch(getPayu(payload));
  //   }
  // }, [hashValue]);

  useEffect(() => {
    if (sessionId) {
      let checkoutOptions = {
        paymentSessionId: sessionId,
        redirectTarget: "_self", //optional (_self or _blank)
        returnUrl: `${
          process.env.REACT_APP_CONFIRM_PAYEMNT +
          "?tripId=" +
          tripCheckoutData?.id
        }`,
      };

      cashfree.checkout(checkoutOptions);
    }
  }, [sessionId]);

  const onConfirmPayBtn = (data, code) => {
    let tripData = {};
    if (type === tripEnumObject?.rental) {
      tripData = {
        type: params?.type,
        rateId: params?.rateId,
        slabId: params?.slabId,
        sourceLocation: pickupLatLng?.[0]?.lat
          ? [pickupLatLng?.[0]?.lat, pickupLatLng?.[0]?.lng]
          : [params?.sourceLat, params?.sourceLng],
        sourceAddress:
          JSON.parse(sessionPickup)?.description ||
          JSON.parse(sessionPickup)?.formatted_address,
          scheduledTime: dateOne,
      };
    } else {
      tripData = {
        type: params?.type,
        distance: params?.distance,
        rateId: params?.rateId,
        riderId: "",
        sourceLocation: [params?.sourceLat, params?.sourceLng],
        destinationLocation: [params?.destinationLat, params?.destinationLng],
        eta: params?.eta,
        googleResponse: {},
        polyLine: decodedPoints,
        scheduledTime: dateOne,
        returnTime: endDateOne,
        sourceAddress:
          JSON.parse(sessionPickup)?.description ||
          JSON.parse(sessionPickup)?.formatted_address,
        destinationAddress:
          JSON.parse(sessionDrop)?.description ||
          JSON.parse(sessionDrop)?.formatted_address ||
          (JSON.parse(sessionDrop)?.vicinity &&
            JSON.parse(sessionDrop)?.name +
              ", " +
              JSON.parse(sessionDrop)?.vicinity) ||
          JSON.parse(sessionDrop)?.name,
      };
    }

    if (
      couponApplyDate?.data?.[0]?.id ||
      couponRentalApplyDate?.data?.[0]?.id
    ) {
      tripData = {
        ...tripData,
        couponId:
          couponApplyDate?.data?.[0]?.couponId ||
          couponRentalApplyDate?.data?.[0]?.couponId,
      };
    }
    dispatch(getTripCheckout(tripData, navigate));
  };
  useEffect(() => {
    if (rideStatus) {
      dispatch(getCancelReason());
      dispatch(
        getTrip({
          id: state?.tripCheckout?.tripDetails?.id || state?.tripCheckout?.id,
        })
      );
    }
  }, [rideStatus]);

  const tripPrice =
    sessionStorage?.getItem("tripPrice")?.length > 0 &&
    JSON.parse(sessionStorage?.getItem("tripPrice"));
  const cabFacilities =
    tripPrice?.Facilities || tripData?.facilities || 
     tripPrice?.MasterCarType?.Facilities ||
    tripPrice?.masterCarType?.Facilities;
  const baseFarePerKM =
    (state?.tripCheckout?.amount ||
      state?.tripCheckout?.price ||
      tripPrice?.baseFare || tripPrice?.totalAmount) /
    (state?.tripCheckout?.tripDetails?.actualDistance ||
      state?.tripCheckout?.actualDistance ||
      tripPrice?.distance);

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="space-evenly"
      className="dashboardBgColor"
      sm={12}
    >
      <Grid item className="bgWhite padding30 h100Scroll" md={5.5} xs={12}>
        <Grid
          item
          container
          direction="column"
          justifyContent="space-between"
          sm={12}
        >
          <Grid item container>
            <Grid item md={11} xs={10.5}>
              <Typography className="font18 fontMedium colorBlue">
                {rideStatus ? "Upcoming ride details" : "Confirm your location"}
              </Typography>
            </Grid>
            
           {rideStatus ?  <Grid item xs={0.5}>
              <Button className='colorPrimary'onClick={(event, index) => handleClick(event,index)}>
              <MoreIcon />
              </Button>
              <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
                  >
                    {status !== tripEnumObject?.outStationRound &&
                    <MenuItem  onClick={handleCancelClose}>
                      <ListItemIcon>
                        <img src={cancel} alt="cancel"/>
                      </ListItemIcon>
                       Cancel Ride
                    </MenuItem>}
                    <MenuItem>
                      <ListItemIcon>
                      <img src={share} alt="share"/>
                      </ListItemIcon>
                      Share Ride
                    </MenuItem>
                 </Menu>
              
            </Grid>: null}
          </Grid>

          <Grid
            item
            container
            direction="row"
            alignItems="center"
            className="marginTop"
          >
            <Grid item xs={1}>
              <img src={pickup} alt="pickup" />
            </Grid>
            <Grid item xs={10} md={8}>
              <Typography className="font14">
                <Tooltip
                  title={
                    state?.tripCheckout?.tripDetails?.sourceAddress ||
                    state?.tripCheckout?.sourceAddress ||
                    JSON.parse(sessionPickup)?.description ||
                    JSON.parse(sessionPickup)?.formatted_address ||
                    ride?.sourceAddress
                  }
                  placement="bottom"
                >
                  {truncateComment(
                    state?.tripCheckout?.tripDetails?.sourceAddress ||
                      state?.tripCheckout?.sourceAddress ||
                      JSON.parse(sessionPickup)?.description ||
                      JSON.parse(sessionPickup)?.formatted_address ||
                      ride?.sourceAddress,
                    70
                  )}
                </Tooltip>
              </Typography>
            </Grid>
            {!rideStatus ? (
              <Grid item className="textAlignEnd" md={3} xs={1}>
                <Button onClick={onClickEditBtn}>
                  <img src={editIcon} alt="editIcon" />
                </Button>
              </Grid>
            ) : null}
          </Grid>
          {type !== tripEnumObject?.rental && (
            <Grid item container direction="row" alignItems="center">
              <Grid item xs={1}>
                <img src={drop} alt="drop" />
              </Grid>
            <Grid item xs={10} md={8}>
                <Typography className="font14">
                  <Tooltip
                    title={
                      state?.tripCheckout?.tripDetails?.destinationAddress || ride?.destinationAddress || 
                      state?.tripCheckout?.destinationAddress ||
                      JSON.parse(sessionDrop)?.description
                    }
                    placement="bottom"
                  >
                    {truncateComment(
                      (state?.tripCheckout?.tripDetails?.destinationAddress || ride?.destinationAddress ||
                        state?.tripCheckout?.destinationAddress ||
                        JSON.parse(sessionDrop)?.description ||
                        JSON.parse(sessionDrop)?.name ) ||
                        (JSON.parse(sessionDrop)?.vicinity &&(JSON.parse(sessionDrop)?.name  + ", " +
                          JSON.parse(sessionDrop)?.vicinity)),
                      90
                    )}
                  </Tooltip>
                </Typography>
              </Grid>
              {!rideStatus && (
                 <Grid item className="textAlignEnd" md={3} xs={1}>
                 <Button onClick={onClickEditBtn}>
                   <img src={editIcon} alt="editIcon" />
                 </Button>
               </Grid>
              )}
               
            </Grid>
          )}
          {type !== tripEnumObject?.outStationRound ? (
            <Grid item container direction="row">
              <Grid item xs={1}>
                <img src={myrideIcon} alt="trip" />
              </Grid>
              <Grid item xs={4} md={3}>
                <Typography className="colorBlue fontMedium">
                  {status}
                </Typography>
              </Grid>
              {!rideStatus &&  (
                <><Grid item xs={6} md={4}>
                <Typography className="fontMedium">
                  {dateFormate(
                    state?.tripCheckout?.tripDetails?.scheduledTime ||
                      state?.tripCheckout?.scheduledTime ||
                      dateOne,
                    "calendar"
                  )}
                </Typography>
              </Grid>
                <Grid item className="textAlignEnd" xs={0.5} md={4}>
                  <Button onClick={onClickEditBtn}>
                    <img src={editIcon} alt="editIcon" />
                  </Button>
                </Grid>
                </>)}
            </Grid>
          ) : (
            <Grid
              item
              container
              sx={{ direction: { xs: "column", md: "row" } }}
            >
              <Grid item xs={1}>
                <img src={myrideIcon} alt="trip" />
              </Grid>
              <Grid item md={2}>
                <Typography className="colorBlue fontMedium">
                  {status}
                </Typography>
              </Grid>
              <Grid item md={3}>
                <Typography className="fontMedium">
                  {dateFormate(
                    state?.tripCheckout?.tripDetails?.scheduledTime ||
                      state?.tripCheckout?.scheduledTime ||
                      dateOne,
                    "calendar"
                  )}
                </Typography>
              </Grid>
              <Grid item md={4}>
                <Typography className="fontMedium">
                  {dateFormate(
                    state?.tripCheckout?.tripDetails?.returnTime ||
                      state?.tripCheckout?.returnTime ||
                      endDateOne,
                    "calendar"
                  )}
                </Typography>
              </Grid>
              {!rideStatus ? (
                <Grid item className="textAlignEnd displayNone" md={2}>
                  <Button onClick={onClickEditBtn}>
                    <img src={editIcon} alt="editIcon" />
                  </Button>
                </Grid>
              ) : null}
            </Grid>
          )}
        </Grid>

        {rideStatus ? (
          <Grid item container className="dashedTopLine1px" direction="column">
            <Grid item container className="marginTop">
              <Grid item>
                <img src={calender} alt="calendar" />
              </Grid>
              <Grid item className="marginLeft10">
                <Typography className="colorBlack fontSemi">
                  Start Time
                </Typography>
              </Grid>
            </Grid>
            <Grid item container className="colorBlack">
              <Grid item className="pl30" md={3} xs={5}>
                <Typography className="font14">
                  {dateFormate(
                    state?.tripCheckout?.tripDetails?.scheduledTime ||
                      state?.tripCheckout?.scheduledTime,
                    "MMM DD, YYYY"
                  )}
                </Typography>
              </Grid>
              <Grid item container xs={6} className="marginLeft20">
                <Grid item >
                  <img className="wh18" src={clock} alt="clock" />
                </Grid>
                <Grid item md={4} xs={6} className="marginLeft10">
                  <Typography className="font14">
                    {dateFormate(
                      state?.tripCheckout?.tripDetails?.scheduledTime ||
                        state?.tripCheckout?.scheduledTime,
                      "hh:mm a"
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ) : null}
        {rideStatus ? (
          <Grid item container className="dashedTopLine1px" alignItems="center">
            <Grid item xs={6} md={4}>
              <img
                src={tripData?.MasterCarType?.carImg}
                alt="WhiteCar"
                className="wh80"
              />
              <Typography className="marginLeft20">
                {tripData?.MasterCarType?.carType}
              </Typography>
            </Grid>
            <Grid item xs={6} md={8}>
              <Typography className="colorGrey font16 fontNormal">
                We will assign your driver before 60min of your trip{" "}
              </Typography>
            </Grid>
          </Grid>
        ) : null}
        <Grid
          item
          container
          md={12}
          justifyContent="space-between"
            alignItems="center"
            className="dashedTopLine1px"
        >
          <Grid item md={5}>
            <Typography className="colorBlack font20 fontMedium">
              {rideStatus ? "Total Fare" : "Estimation"}
            </Typography>
            {params?.type !== (tripEnumObject?.outStationRound) && ( 
            <Typography className="fontSemi colorGrey marginTop">
              Base fare @{parseFloat(baseFarePerKM)?.toFixed(2)}/km
            </Typography>)}
          </Grid>
          <Grid item md={5} className="textAlignEnd">
            {couponApplyDate?.data?.[0]?.id ||
            couponRentalApplyDate?.data?.[0]?.id ? (
              <Typography className="colorBlack font20 fontSemi">
                {" "}
                {`₹ ` +
                  parseFloat(
                    couponApplyDate?.data?.[0]?.discountedAmount ||
                      couponRentalApplyDate?.data?.[0]?.discountedAmount ||
                      couponApplyDate?.data?.[0]?.totalAmount ||
                      couponRentalApplyDate?.data?.[0]?.totalAmount
                  )}
              </Typography>
            ) : (
              <Typography className="colorBlack font20 fontSemi">
                {`₹ ` +
                  parseFloat(
                    tripPrice?.totalAmount ||
                      state?.tripCheckout?.amount ||
                      state?.tripCheckout?.price ||
                      0
                  )?.toFixed(2) || "0"}
              </Typography>
            )}
            {!rideStatus && type !==  tripEnumObject?.outStationRound ? (
              <Typography className="fontSemi colorGrey marginTop">
                {tripPrice?.distance ||
                  state?.tripCheckout?.tripDetails?.actualDistance}
                km
              </Typography>
            ) : null}
          </Grid>
        </Grid>
        {type ===  tripEnumObject?.outStationRound &&
        
        <Grid item
          container
          md={12}
          justifyContent="space-between"
          alignItems="center"
        >
       { fareData(tripPrice)?.map((fare,index) =>
       <>
          <Grid item md={5} className="marginTop">
            <Typography className="colorBlack ">
              {fare.heading}
            </Typography>
            <Typography className="colorGrey font14">
              {fare.subHeading}
            </Typography>
          </Grid>
          <Grid item md={5} className="textAlignEnd">
            <Typography className="colorBlack fontSemi">
              {'₹ ' + fare?.amount}
            </Typography>
          </Grid>
          </>)}
        </Grid>} 

        {!rideStatus ? (<Grid>
          <CouponDesign />
        </Grid>) : null}
        <Grid item container className="dashedTopLine1px" direction="column">
          <Grid item>
            <Typography className="colorPrimary font18 marginBottom7">
              Facilities we will provide on your trip
            </Typography>
          </Grid>
          <Grid
            item
            container
            direction="row"
            justifyContent="start"
            alignItems="baseline"
          >
            {cabFacilities &&
              cabFacilities?.map((facility) => (
                <Grid
                  item
                  container
                  md={2.5}
                  xs={6}
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  className="alignTextCenter"
                  key={facility?.id}
                >
                  <Grid item className="facilityImg wh37 justifyCenter">
                    <img
                      src={facility?.img?.url}
                      alt={facility?.img?.name}
                      onError={(e) => handleOnError(e, facility?.img?.name)}
                    />
                  </Grid>
                  <Grid item className="facilityLabel">
                    <Typography className="colorBlue">
                      {facility?.name}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
          </Grid>
        </Grid>
        <Grid item container direction="column" className="dashedTopLine1px">
          <Grid item>
            <Typography className="colorBlue">Rule Inclusions</Typography>
          </Grid>
          <Grid item className="marginBlock10">
            <Typography>
              {(rideInclusion || ride?.rideInclusions)?.map((point) => (
                <li>{point}</li>
              ))}
            </Typography>
          </Grid>
        </Grid>
        {!rideStatus ? (
          <Grid item container className="dashedTopLine1px">
            <Grid item xs={12} className="alignTextCenter">
              <CommonForm
                formData={formData}
                button={"Confirm and pay now"}
                onSubmittBtn={onConfirmPayBtn}
                loading={loading}
              />
            </Grid>
          </Grid>
        ) : null}
      </Grid>
     {(pathData || pickupLatLng) &&<Grid item className="h100p" sx={{marginTop:{xs:'20px', sm:'0px'}}} md={5.5} xs={12}>
        {pathData ? <Map paths={pathData} status={status} />:
         (Object.keys(pickupLatLng)?.length > 0 || pickupLatLng?.length > 0)
         ? type === (tripEnumObject?.rental) && <Map paths={pickupLatLng} status={status}/> : null}
      </Grid>}
      {openDialog && <CancelReason
      openDialog={openDialog}
      cancelReasonData={cancelReasonData}
      tripId={state?.tripCheckout?.id}
      handleClose={handleCancelClose}/>}
    </Grid>
  );
}

export default ComfirmPay;
